import React from "react";
import "./Started.css";

const Started = () => {
  return (
    <section className="s-wrapper">
      <div className="s-container innerWidth">
        <h2>Get started with Homyz</h2>
        <p>
          Subscribe and find super attractive price quotes from us. <br />
          Find your residence soon
        </p>
        <button className="btn">Get Started</button>
      </div>
    </section>
  );
};

export default Started;
